import type { ReactNode } from "react"
import { useLocation } from "@tanstack/react-router"
import { SidebarInset, SidebarTrigger } from "@uavity-core/ui/components/sidebar"
import { cn } from "@uavity-core/ui/lib/utils"
import { AppChrome } from "./app-chrome"
import { BottomNav } from "./bottom-nav"
import { PerformanceMonitor } from "./seo/PerformanceMonitor"

export function PublicAppFrame({ children }: { children: ReactNode }) {
  const pathname = useLocation().pathname
  const mapMode = pathname === "/" || pathname === "/map"

  return (
    <SidebarInset className={cn("bg-background peer flex min-h-0 flex-col overflow-hidden", mapMode ? "h-dvh pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0" : "min-h-dvh")}>
      <header
        className={cn(
          "relative z-20 flex shrink-0 items-center gap-2 border-b border-border/60 bg-card/95 px-3 py-1.5 sm:px-5 lg:px-6"
        )}
      >
        <SidebarTrigger
          variant="outline"
          className="h-11 w-11 shrink-0"
        />
        <div className="min-w-0 flex-1">
          <AppChrome />
        </div>
      </header>
      <div
        className={cn(
          "relative flex min-h-0 flex-1 flex-col",
          mapMode
            ? "overflow-hidden p-0"
            : "overflow-y-auto overscroll-y-contain px-4 pb-[calc(theme(spacing.20)+env(safe-area-inset-bottom))] pt-5 sm:px-6 lg:px-10"
        )}
      >
        <PerformanceMonitor />
        {children}
      </div>
      <BottomNav />
    </SidebarInset>
  )
}
